import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OTPService } from './otp.service';

@Component({ template: `` })
export class OtpCallbackComponent implements OnInit {

  constructor(private _otpService: OTPService, private _router: Router) { }

  ngOnInit() {
    window.location.hash ?
      this._otpService.requestAuthenticationCallback() :
      this._router.navigate(['auth/unauthorized']);
  }
}
